import { GenericEntity } from './common.model';
import { DictionaryItem } from './dictionary.model';
import { DocumentAdditionalData, SalespointDocument } from './document.model';
import { Party, PartyRole } from './party.domain';
import { InsuredProduct } from './product.domain';
import { Agent, Branch } from './structure.domain';
import { SystemUser } from './user.model';

export class PolicyholderRequest {
    policyholder: Party = new Party();
    policyholderIsInsuredPerson: boolean = true;
}

export class OfferRequest extends PolicyholderRequest {
    insuredPersonList: Party[] = [];
}

export class Offer extends GenericEntity implements SalespointDocument {
    number: string;
    agent: Agent;
    branch: Branch;
    partyList: Party[];
    partyRoleList: PartyRole[];
    premium: number;
    productList: InsuredProduct[];
    seller: SystemUser;
    status: DictionaryItem;
    statusDate: string;
    additionalData: DocumentAdditionalData;
    summaryStepEnabled: boolean;
}

export enum ClauseType {
    CLIENT_DECLARATION_1 = 'CLIENT_DECLARATION_1',
    CLIENT_DECLARATION_2 = 'CLIENT_DECLARATION_2',
    AGENT_DECLARATION_1 = 'AGENT_DECLARATION_1',
    AGENT_DECLARATION_2 = 'AGENT_DECLARATION_2',
    AGENT_DECLARATION_3 = 'AGENT_DECLARATION_3',
    CLIENT_CONDITION_1 = 'CLIENT_CONDITION_1',
    CLIENT_CONDITION_2 = 'CLIENT_CONDITION_2',
}



export class OfferHeader {
    id: number;
    accent: boolean;
    motor: boolean;
    property: boolean;
    frontier: boolean;
    policyholderName: string;
    creationDate: string;
    premium: number;
    status: DictionaryItem;
    number: string;
    agencyInfo: string;
    sellerInfo: string;
}

export class Agency {
    code: string;
    name: string;
}

export class Seller {
    fullName: string;
}
